import React from "react";
import * as stylex from "@stylexjs/stylex";
import type { Label as IssueLabel } from "../types";
import "../styles/variables.stylex";
import { ZendeskThemeVariables } from "../styles/variables.stylex";
type Props = {
  label: IssueLabel;
};

/**
 * Renders a compact Linear label pill for issue metadata inside the Zendesk widgets.
 *
 * @param props The component properties described by {@link Props} .
 * @returns The rendered content.
 */
export const Label = (props: Props) => {
  const {
    label
  } = props;
  return <div className="sx-kz0k9k sx-euugli sx-78zum5 sx-6s0dn4 sx-1n2onr6 sx-exx8yu sx-y13l1i sx-18d9i69 sx-163pfp sx-17rw0jw sx-174e0gf sx-mkeg23 sx-1y0btm7 sx-1ke0ykx sx-b3r6kr sx-lyipyv">
      <LabelDot color={label.color} />
      <div className="sx-kz0k9k sx-euugli sx-16vho4v sx-1lliihq sx-b3r6kr sx-uxw1ft sx-lyipyv">{label.name}</div>
    </div>;
};
type LabelDotProps = {
  color: string;
};

/**
 * Shows the label color in the leading dot of {@link Label} .
 *
 * @param props The component properties described by {@link LabelDotProps} .
 * @returns The rendered content.
 */
export function LabelDot({
  color
}: LabelDotProps) {
  return <div {...stylex.props([styles.labelDot, styles.labelDotColor(color)])} />;
}
const styles = {
  labelDot: {
    kzqmXN: "sx-1wc42o8",
    kZKoxP: "sx-egnrdp",
    kaIpWk: "sx-16rqkct",
    kmuXW: "sx-2lah0s",
    $$css: true
  },
  labelDotColor: (color: string) => [{
    kWkggS: color != null ? "sx-l8spv7" : color,
    $$css: true
  }, {
    "--x-backgroundColor": color != null ? color : undefined
  }]
};